import {gql} from 'apollo-boost';

export const TEACHER_NAME_FIELDS = gql`
  fragment TeacherNameFields on Teacher {
    id
    code
    firstNameLocal
    lastNameLocal
    firstNameEng
    lastNameEng
    prefix {
      id
      nameShortLocal
      nameShortEng
    }
  }
`;

export const STUDENT_NAME_FIELDS = gql`
  fragment StudentNameFields on Student {
    id
    code
    firstNameLocal
    lastNameLocal
    firstNameEng
    lastNameEng
    prefix {
      id
      nameShortLocal
      nameShortEng
    }
  }
`;
